import { render, staticRenderFns } from "./BulkActionsSidebar.vue?vue&type=template&id=7b4b7866&scoped=true"
import script from "./BulkActionsSidebar.vue?vue&type=script&lang=js"
export * from "./BulkActionsSidebar.vue?vue&type=script&lang=js"
import style0 from "./BulkActionsSidebar.vue?vue&type=style&index=0&id=7b4b7866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4b7866",
  null
  
)

export default component.exports